import { Pipe, PipeTransform } from '@angular/core';

import * as day from 'dayjs';

/**
 * Simple pipe to convert a date string (or variation) string | number | Date | Dayjs | null | undefined
 * to a Dayjs object.
 */
@Pipe({
  name: 'toDayjs',
})
export class ToDayJsPipe implements PipeTransform {
  transform(date: day.ConfigType, format?: day.OptionType): day.Dayjs | undefined {
    if (!date) return undefined;

    const formatted = day(date, format);
    return formatted.isValid() ? formatted : undefined;
  }
}
